export const dp_r2 = '2px';
export const dp_r4 = '4px';
export const dp_r8 = '8px';
export const dp_r12 = '12px';
